module.exports = __webpack_public_path__ + "static/media/brownbutton.e2c36870.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/portfolio/brownbutton/brownbutton.png
// module id = 58
// module chunks = 0